import { render } from "./MwUserInfoForm.vue?vue&type=template&id=460498da&scoped=true"
import script from "./MwUserInfoForm.vue?vue&type=script&lang=js"
export * from "./MwUserInfoForm.vue?vue&type=script&lang=js"

import "./MwUserInfoForm.vue?vue&type=style&index=0&id=460498da&scoped=true&lang=scss"

import exportComponent from "/Users/mac/Documents/Tranzak/Frontend/tzpay/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-460498da"]])

export default __exports__